module.exports = __webpack_public_path__ + "assets/img/banlie.bca22801.png";